import Migration from "./Migration.js";

export default Migration;
